<template>
  <BaseModal
    :value="true"
    :modal-title="$t('controls.delete_control')"
    @click:outside="close"
    @keydown.esc="close"
    @close="close"
  >
    <template #modal>
      <div class="text-center">
        <BaseParagraph v-text="$t('controls.delete_control_confirmation')" />
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import organizationApi from "@/core/Services/organization.api";
export default {
  name: "ControlDeleteDialog",
  props: {
    selectedControl: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      try {
        await organizationApi.deleteOrganizationValidationSchema({
          organizationId: this.$route.params.organizationId,
          validationSchemaId: this.selectedControl.id,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("controls.control_deleted_successfully"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.$emit("control-deleted");
      this.$emit("close");
    },
  },
};
</script>
